// extracted by mini-css-extract-plugin
module.exports = {"menuToggle":"MenuToggle_menuToggle__wojlc","icon":"MenuToggle_icon__mhrFN"};